import { useQuery } from "@tanstack/react-query";
import { getWeeklyReviewSummary } from "../../api/bReviewsApi";

/**
 * Fetch the latest weekly AI review summary for an organisation.
 */
export const useGetWeeklySummary = (params, enabled = true) => {
  return useQuery({
    queryKey: ["weekly-review-summary", params],
    queryFn: () => getWeeklyReviewSummary(params),
    enabled: !!params?.organisationId && enabled,
    staleTime: 1000 * 60, // cache for 1 minute
    refetchOnWindowFocus: false,
  });
};
